
(function (faq, $, undefined) {

    // public configuration variable
    faq.config = {};

    // bind events and such to the DOM
    // private function
    function bindEvents() {
        $(window).on('load', function () {
            faq.accordion();
            faq.listFilter();
        });

        $(window).on('resize', function () {

        });
    }

    faq.accordion = function () {
        var $accordionHeading = $('.accordion .accordion-header');
        var $accordionContent = $('.accordion .accordion-content');

        $accordionHeading.on('click', function () {
            var $this = $(this);
            var open = false;

            if (!$this.hasClass('open')) {
                open = true;
            }

            $accordionHeading.removeClass('open');
            $accordionContent.slideUp();

            if (open === true) {
                $this.nextAll('.accordion-content').slideDown();
                $this.addClass('open');
            }
        });
    }

    faq.listFilter = function () {
    	var $listItem = $('.accordion > li');
        var $noResults = $('.list-no-results');

        $('.list-filter input[type="text"]').on('keyup', function () {
            var totalItemsHidden = 0;
            var searchInput = $(this).val();

            if (searchInput.trim().length < 3) {
                //input is empty or not long enough to be valid, show all in list
                $listItem.show();
                $noResults.hide();
                return;
            }

            //search by each word in the input array
            var searchWords = searchInput.split(' ');
            $listItem.hide();

            //loop through each list item
            $listItem.each(function (index, item) {

                //loop through input text array for matching words
                var foundWords = 0;
                for (var i = 0; i < searchWords.length; i++) {

                    if ($(this).text().toUpperCase().indexOf(searchWords[i].toUpperCase()) == -1) {
                        totalItemsHidden++;
                        $(this).hide();
                        break;
                    }
                    else {
                        $(this).show();
                    }
                }
            });

            // if all items are hidden, show message
            if ($listItem.length == totalItemsHidden) {
                $noResults.show();
            }
            else {
                $noResults.hide();
            }
        });
    }

    // initialize object
    // this is a public function
    faq.init = function () {
        bindEvents();
    }
})(window.faq = window.faq || {}, jQuery);

 //self initialize once the DOM is loaded
(function ($) {
    faq.init();
}(jQuery));


// WEBPACK FOOTER //
// ./Content/js/app/faq.js